import { RequestChannel } from "@vyne-shared/api/VynePayments/responses";
import type { ContactValidity } from "./ContactError";

/** Compute Contact Validity. */
export function getContactValidity(
    requestChannel: RequestChannel,
    currentRequestChannel: RequestChannel,
    value: string | undefined,
    valid: boolean,
): ContactValidity {
    const { active, present } = getActivePresent(requestChannel, currentRequestChannel, value);

    return valid ? "ok" : present ? getOtherThanOkValidityPresent(active) : getOtherThanOkValidityNotPresent(active);
}

function getActivePresent(
    requestChannel: RequestChannel,
    currentRequestChannel: RequestChannel,
    value: string | undefined,
) {
    const active = currentRequestChannel === requestChannel || currentRequestChannel === RequestChannel.Both;
    const present = !!value;
    return { active, present } as const;
}

function getOtherThanOkValidityPresent(active: boolean) {
    return active ? "error" : "warning";
}

function getOtherThanOkValidityNotPresent(active: boolean) {
    return active ? "missing-error" : "missing-ok";
}
